import { Route, Routes } from "react-router-dom";
import WorldMap from "./components/map/WorldMap";
import { ItineraryWizard } from "./pages/ItineraryWizard";

const Router = ({ mapDevOptions }) => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <WorldMap devOptions={mapDevOptions} />
        }
      />
      <Route
        path="/cwd"
        element={
          <WorldMap devOptions={mapDevOptions} />
        }
      />
      <Route path="/wizard" element={<ItineraryWizard />} />
    </Routes>
  );
};

export default Router;
